module.exports = __webpack_public_path__ + "static/media/msword-icon.22165c0f.png";